import type { IconData } from '@stacksjs/iconify-core'

export const gh4x3: IconData = {
  "body": "<path fill=\"#006b3f\" d=\"M0 0h640v480H0z\"/><path fill=\"#fcd116\" d=\"M0 0h640v320H0z\"/><path fill=\"#ce1126\" d=\"M0 0h640v160H0z\"/><path fill=\"#000001\" d=\"m320 160l52 160l-136.1-98.9H404L268 320z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default gh4x3
